import React from 'react';
import styled from 'styled-components';

import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Typography as T } from '@dev/ee-components';

import { getEmailsStore } from '@api/store/emails/actions';
import { useSmsData } from '../hooks/useSMSData';
import { ViewEmailComonentsProps } from '../ViewEmailProps';

const EmailWraperContainer = styled.div<{ isSmsScreen: boolean }>`
    margin-top: 8px;
    padding: 24px 0;
    ${(props) =>
        props.isSmsScreen &&
        `
        & iframe {
            height: unset;
        }
    `}
`;

const EmailWraper = (props: ViewEmailComonentsProps): JSX.Element => {
    const { t } = useTranslation();
    const { isSmsScreen } = props;
    const { email } = useSelector(getEmailsStore);
    const smsData = isSmsScreen && useSmsData(props.msgId);

    return (
        <EmailWraperContainer isSmsScreen={isSmsScreen}>
            <T variant="h1">{isSmsScreen ? t('sms') : t('email')}</T>
            <iframe
                title={email?.Preview?.Subject || (isSmsScreen && 'SMS') || ''}
                srcDoc={email?.Preview?.Body || smsData?.TextMessage}
                sandbox=""
            />
        </EmailWraperContainer>
    );
};

export default EmailWraper;
